<template>
  <div class="results">
    <div
      v-for="category in categories"
      :key="category"
      class="result__item"
    >
      <div class="header d-flex justify-content-between align-items-start align-items-md-center flex-column flex-md-row mb-4">
        <slot name="header">

          <h5 class="header__title">
            {{ categoryTitle(category) }}
            <!-- <font-awesome-icon icon="info-circle" size="xs" title="" /> -->
          </h5>

          <router-link
            v-if="!hasUserSubscriptionAccess"
            :to="{ name: 'subscribe' }"
            class="header__link"
          >Ver a lista completa</router-link>
        </slot>
      </div>

      <div>
        <ResultItem
          v-for="item in items(category)"
          :key="item.tag"
          :class="{ active : isItemSelected(item) }"
          :blur="isBlur(item)"
          @click="!isBlur(item) ? select(item.tag) : null"
        >
          {{ item.tag }}
          <template #quantity v-if="item.count">{{ item.count }}</template>
        </ResultItem>
      </div>
    </div>
  </div>
</template>

<script>
import ResultItem from '@/components/tools/instatags/ResultItem'
import { mapGetters } from 'vuex'

export default {
  components: {
    ResultItem,
  },

  props: {
    resultSet: { type: Object, required: true },
  },
  
  data: () => ({
    selected: [],

    categoriesLabel: {
      best_related: {
        title: 'Hashtags de maior alcance',
        description: 'The best related tags for this category',
      },

      related: {
        title: 'Hashtags relacionadas',
        description: 'The related tags for this category',
      },

      top: {
        title: 'Top hashtags usadas em conjunto',
        description: 'The most used tags for this category',
      },
    }
  }),

  computed: {
    ...mapGetters('user', ['hasUserSubscriptionAccess']),

    categories () {
      return Object.keys(this.resultSet)
    },

    items () {
      return (category) => this.resultSet[category]
    },

    categoryTitle () {
      return (category) => this.categoriesLabel[category].title;
    },

    isItemSelected () {
      return (item) => this.selected.includes(item.tag)
    },

    isBlur () {
      return (item) => item.tag === null
    }
  },

  methods: {
    reset () {
      this.selected = []
      this.$emit('select', this.selected)
    },

    select (tag) {
      const indexOf = this.selected.indexOf(tag)

      if (indexOf > -1) {
        this.selected.splice(indexOf, 1)
      } else {
        this.selected.push(tag)
      }

      this.$emit('select', this.selected)
    },
  }
}
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .results {
    display: flex;
    flex-direction: column;
    gap: 48px; 

    .result__item {
      background: $purple70;
      padding: 24px;
      border-radius: 8px;
    }
  }

  .header {
    &__title {

    }

    &__link {
      color: #ff8000;
      font-weight: 700;
      font-size: 15px;
    }
  }
</style>